import { render, staticRenderFns } from "./SimInfo.vue?vue&type=template&id=159e497b&scoped=true"
import script from "./SimInfo.vue?vue&type=script&lang=js"
export * from "./SimInfo.vue?vue&type=script&lang=js"
import style0 from "./SimInfo.vue?vue&type=style&index=0&id=159e497b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159e497b",
  null
  
)

export default component.exports